export const socialImageUrls: string[] = [
    require("../assets/Images/General/SP25_Retreat_Canes.jpg"),
    require("../assets/Images/General/photo_strip1.JPG"),
    
    require("../assets/Images/General/photo_strip3.JPG"),
    require("../assets/Images/General/SP25_Retreat_Snowman2.jpg"),
    require("../assets/Images/General/donutGroup.JPEG"),
   
    require("../assets/Images/General/Hike.png"),
    require("../assets/Images/General/photo_strip2.jpg"),

    require("../assets/Images/General/tabling.jpg"),
    

    // Add more image URLs as needed
];
